import { appCallNative } from '@hb/bridge-core';
import { INativeProxy, IAppNative } from './lib/interface';
import env from 'utils/env';
import { mainStoreWithoutHook as mainStore } from '@/stores';
import request from '../../utils/request';
import appConst from '../../const/app.const';

// app bridge文档 https://gitlab.hellobike.cn/Publics/DocTorrent/blob/master/H5%E8%B0%83%E7%94%A8%E6%89%80%E6%9C%89%E7%9A%84app%E6%96%B9%E6%B3%95%E6%94%AF%E6%8C%81%E7%89%88%E6%9C%AC.md

// const { callNative } = Native;
const httpReg = /(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/;

const NativeProxy: INativeProxy = {
  // 跳转链接
  goLinkUrl(url) {
    // 如果是链接
    if (url && typeof url === 'string' && httpReg.test(url)) {
      // 打开新的web-view
      window.location.href = `hellobike://hellobike.com/openWeb?webUrl=${url}`;
      return Promise.resolve();
    }

    // @ts-ignore
    window.location.href = url;
    return Promise.resolve();
  },
  redirectTo(url) {
    return NativeProxy.goLinkUrl(url);
  },
  goBack(delta) {
    return appCallNative({
      classMap: 'NavBar',
      method: 'goBack',
      params: delta,
    });
  },
  async getCityInfo() {
    const res: any = await appCallNative({
      classMap: 'SystemUtil',
      method: 'getCityInfo',
      params: null,
    });
    const { data } = res || {};
    return {
      citycode: data.cityCode,
      cityCode: data.cityCode,
      adcode: data.adCode,
      adCode: data.adCode,
      cityGuid: data.cityGuid,
      city: data.cityName,
      latitude: data.lat,
      longitude: data.lng,
    };
  },
  // 安卓需要在外层传递isShow
  showNaviBar(show) {
    const params = {
      method: 'showNaviBar',
      params: { isShow: show },
      classMap: 'NavBar',
      isShow: show,
    };

    if (env.isAndroid) {
      return new Promise(() => {
        const data = {
          classMap: params.classMap,
          method: params.method,
          params: JSON.stringify(params),
          callbackId: 'bridge_core_callback_99999',
        };
        const dataStr = JSON.stringify(data);
        (<any>window).AppFunctions.callNative(dataStr);
      });
    }
    return appCallNative(params);
  },
  setTitle(title) {
    return appCallNative({
      classMap: 'NavBar',
      method: 'setPageTitle',
      params: {
        title,
      },
    });
  },
  /**
   * @param {{ isShowStatusBar: boolean }}
   */
  setStatusBar(params: any) {
    return appCallNative({
      classMap: 'NavBar',
      method: 'setStatusBar',
      params,
    });
  },
  setStatusBarColor(backgroundColor) {
    return appCallNative({
      classMap: 'NavBar',
      method: 'setStatusBarColor',
      params: {
        colorCode: backgroundColor,
      },
    });
  },
  async getTokenAndKey(needLogin) {
    if (mainStore.userInfo.token) {
      return mainStore.userInfo;
    }

    if (needLogin) {
      const result: any = await appCallNative({
        classMap: 'User',
        method: 'getTokenAndKey',
        params: {
          needLogin,
        },
      });
      const { data } = result || {};
      if (data && data.token) {
        Object.assign(mainStore.userInfo, {
          token: data.token,
          ticket: data.ticket,
          guid: data.guid || data.userGuid,
          key: data,
          mobile: data.mobile,
        });
      } else {
        mainStore.userInfo = {};
      }

      return mainStore.userInfo;
    }
  },
  /** @description 扫码 */
  scanQRCode() {
    return appCallNative({
      classMap: 'business/scan',
      method: 'scanQRCode',
      params: {},
    });
  },
  /** @description 选择图片 */
  /** @description 选择图片 */
  async chooseImage(args?: any) {
    const res = (await appCallNative({
      classMap: 'business/bike',
      method: 'bikeTakePhoto',
      params: {
        ...Object(args),
        sizeType: args?.sizeType,
        sourceType: args?.sourceType,
        cameraOnly: args?.cameraOnly ? 1 : 0,
      },
    })) as { data: { result: string } } | undefined;
    return { data: res?.data?.result ? [res.data.result] : [] };
  },
  /** @description  选择图片-新版 */
  async chooseImageWithTips(args?: any) {
    const res = (await appCallNative({
      classMap: 'business/moped',
      method: 'ohoTakeHelmetPhoto',
      params: {
        sizeType: args?.sizeType,
        sourceType: args?.sourceType,
        cameraOnly: args?.cameraOnly ? 1 : 0,
        imageUrl: args?.imageUrl, // 示意图
        title: args?.title, // 提示文案
      },
    })) as { data: { url: string } | undefined };
    return { data: res?.data?.url ? [res.data.url] : [] };
  },
  /** @description 上传文件 */
  async uploadFile(url) {
    const res = await request.post(
      {
        action: 'user.account.upload',
        type: 2,
        image: 1,
        file: url,
      },
      {
        apiServer: appConst.UPLOAD_APP_API,
      },
      true,
    );
    return { data: res };
  },
  evCallBackCloseH5() {
    try {
      if (env.isAndroid) {
        return appCallNative({
          classMap: 'business/moped',
          method: 'evCallBackCloseH5',
          params: null,
        });
      }
      return Promise.resolve();
    } catch (e) {
      return Promise.resolve();
    }
  },
};

const AppNative = ({ method, params, classMap = 'Business' }: IAppNative) => {
  if (NativeProxy[method]) {
    return NativeProxy[method].call(NativeProxy, params, classMap);
  }
  return appCallNative({
    classMap,
    method,
    params,
  });
};
export default AppNative;
